import credentials from "../../config/credentials_to_use.json";

export const UPDATE_INTERVAL = 5000; // TODO - Production - Change to : 5000
export const RECORDS_MINUTES = 5; // mins
export const RECORDS_NUMBERS = 20;
export const POLL_MINUTES_BACK = 1;
export const WIDTH = 170;
export const MODAL_DEFAULT_MINS = 10;
export const MINS_BACK = 24 * 60 * 30 * 30;
export const DEVICE_ID = "deviceID";
export const DEVICE_SUBSCRIBE_TOPIC = `nbiot/${DEVICE_ID}/payload`;
export const DEVICE_PIT_STATUS_TOPIC = `nbiot/${DEVICE_ID}/pitstatus`;
export const DEVICE_TECH_STATUS_TOPIC = `nbiot/${DEVICE_ID}/techstatus`;
export const NUMBER_OF_LATEST_RECORDS_TO_FETCH = 10;

// -- Thresholds

export const THRESHOLDS = {

  above_distanceV: 0,
  above_gasTVOC: 1,
  above_voltage: 1,
  above_z: 1,
  delta_distanceV: 10,
  delta_gasTVOC: 10,
  delta_voltage: 10,
  delta_z: 10,
  deviceID: '',
  deviceState: "NSW",
  latitude: -24.397,
  longitude: 135.644,
  normWater: null,
  norm_x: 10,
  norm_y: 2,
  norm_z: 3,
  sdp: "Telstra",
  thresholdGasTime: 8,
  thresholdGasValue: 12,
  thresholdIntrusionValue: 8,
  thresholdPowerValue: 8,
  thresholdPowerVolt: 8,
  thresholdSpatialValue: 35,
  thresholdWaterTime: 8
};

// export const TEMPERATURE_THRESHOLD = 40;
// export const SPATIAL_DEPTH_THRESHOLD = 500;
// export const HUMIDITY_THRESHOLD = 70;
// export const GAS_LEAKAGE_THRESHOLD = 4000;
// export const BATTERY_CHARGE_THRESHOLD = 3;
// export const POWER_LEAKAGE_THRESHOLD = 240;
// export const WATER_TIME_THRESHOLD = 1;
// export const GAS_TIME_THRESHOLD = 2;
// export const POWER_VOLT_THRESHOLD = 3;
// export const INTRUSION_THRESHOLD = 4;

// Credentials
export const USER_POOL_ID = credentials.userPoolId;
export const CLIENT_ID = credentials.clientID;
export const REGION = credentials.regionName;
export const IDENTITY_POOL_ID = credentials.identityPoolId;
export const IOT_HOST = credentials.host;
export const ACCESS_KEY_ID = credentials.accessKeyId;
export const SECRET_ACCESS_KEY = credentials.secretAccessKey;

// Bucket Name
export const BUCKET_NAME = credentials.bucketName;

// Initial (Default) deviceId whose data is to be shown
export const INITIAL_DEVICE_ID = ''; // '0915edd6-0dc8-4f17-a66d-ffe91c3e8c82'; '13c391c5-b022-4973-a044-71b6ea5c24a6/MPA18HM100016360' or '13c391c5-b022-4973-a044-71b6ea5c24a6/MPA18HM100015640'

// Table Names
export const HEARTBEATDATA_TABLE_NAME = 'SP_DevicesTimeSeries_BA';
export const NOTIFICATION_TABLE_NAME = 'SmartPitLid-NotificationSummary';
export const THRESHOLDS_TABLE_NAME = 'SmartPitLid-DeviceThreshold';
export const STATEWISE_DEVICES_TABLE_NAME = 'SmartPitLid-StateWiseDevices';
export const AUSTRALIA_LOCATIONS_TABLE_NAME = 'SmartPitLid-Configuration';
export const DEVICES_TABLE_NAME = 'SmartPitLid-Devices';
export const DEVICE_CORRELATION_BREAKDOWN = 'SmartPitLid-DeviceCorrelationBreakdown';

// Lambda functions
export const DEVICE_RAW_DATA_FUNCTION = 'NP_RawDevicesTableHandler';
export const DEVICE_DATA_FUNCTION = 'NP_ReturnDevicesData';
export const GET_THEME_CONFIGURATION = 'NP_GetThemeConfiguration';
export const UPDATE_THEME_CONFIGURATION = 'NP_UpdateThemeConfiguration';
export const GET_THRESHOLDS_DATA = 'NP_GetThresholdData';
export const UPDATE_THRESHOLDS_DATA = 'NP_UpdateThresholdData';
export const GET_NOTIFICATION = 'NP_GetNotifications';
export const CLOSE_NOTIFICATION = 'NP_CloseNotification';
export const SEARCH_DEVICES = 'NP_SearchDevices';

export const TECH_STATUS_7_DAYS = 'NP_TechStatusLast7Days';
export const TECH_STATUS_30_DAYS = 'NP_TechStatusLast30Days';
export const PIT_STATUS_7_DAYS = 'NP_PitStatusLast7Days';
export const PIT_STATUS_30_DAYS = 'NP_PitStatusLast30Days';
export const GET_CURRENT_STATUS = 'NP_CurrentStatus';

// Y-Axis stepSize Values
export const TEMPERATURE_YAXIS_STEPSIZE = 0;
export const SPATIAL_DEPTH_YAXIS_STEPSIZE = 100;
export const HUMIDITY_YAXIS_STEPSIZE = 0;
export const GAS_LEAKAGE_YAXIS_STEPSIZE = 0;
export const POWER_LEAKAGE_YAXIS_STEPSIZE = 0;
export const BATTERY_CHARGE_YAXIS_STEPSIZE = 1;

// Default Image | To use for profile image when no image is set or broken image or image not found.
export const DEFAULT_PROFILE_IMG = 'assets/images/user-placeholder.png';
export const DEFAULT_LOGO_IMG = 'assets/images/logo.png';

//URLs
export const MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_FIRST_PART = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=';
export const MAP_LAT_LONG_TO_STATES_GOOGLE_API_URL_SECOND_PART = '&result_type=administrative_area_level_1&key=AIzaSyBjjqIGvPrBSjFd_T4se7vXduidGu9qg3c';

//Query Limits
export const INITIAL_QUERY_LIMIT = 10;


// WEBPACK FOOTER //
// ./util/app-constants.js